<template>
  <div class="sourceInfo">
    <div class="top">
      <img v-lazy="require(`../../../assets/sourceInfo.webp`)" alt="" />
      <div class="title">溯源信息</div>
    </div>
    <div class="line"></div>
    <div class="bottom">
      <div class="right">
        <div
          v-for="(item, index) in description"
          :key="index"
          class="detailBox"
        >
          <Detail :description="item"></Detail>
          <img v-lazy="require(`../../../assets/sourceProduct.png`)" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Detail from "./detail";
import { getlifeLogOut } from "@/api/sourceInfo";
export default {
  props: ["barCode"],
  components: { Detail },
  data() {
    return {
      description: [],
    };
  },
  created() {
    getlifeLogOut({ barCode: this.barCode }).then((res) => {
      this.description = res.data.data.list;
    });
  },
  mounted() {},

  methods: {},
};
</script>

<style lang="less" scoped>
.sourceInfo {
  box-sizing: border-box;
  padding: 32px;
  width: 100%;
  min-height: 258px;
  background: #fff;
  border-radius: 24px;
  .top {
    height: 48px;
    display: flex;
    align-items: center;
    img {
      width: 48px;
      height: 48px;
    }
    .title {
      height: 48px;
      line-height: 48px;
      float: left;
      color: rgba(51, 51, 51, 1);
      font-size: 32px;
      font-weight: bold;
      margin-left: 8px;
    }
  }
  .bottom {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    .left {
      width: 48px;

      .leftLine {
        height: 100px;
        border-right: 1px dashed red;
      }
    }
    .right {
      width: 100%;
      min-height: 507px;
      .detailBox {
        width: 100%;
        display: flex;
        justify-content: flex-end;
        position: relative;
        margin-top: 40px;
        img {
          height: 48px;
          width: 48px;
          position: absolute;
          left: 0;
          top: 0;
        }
      }
      .detailBox:nth-child(1) {
        margin-top: 0;
      }
      .detailBox:nth-child(2) {
        margin-top: 40px;
      }
      .detailBox:nth-child(3) {
        margin-top: 40px;
      }
    }
  }
}
.line {
  margin: 24px 0;
  width: 100%;
  background: rgba(226, 228, 234, 1);
  height: 2px;
}
</style>
